import {Component, OnDestroy, OnInit} from '@angular/core';
import {DeclarationService} from '../../services/declaration.service';
import {SortingComponent} from '../../sorting.component';
import {DeclarationReport} from '../../declarationReport';
import {DateAdapter, MatRipple} from '@angular/material/core';
import {DateFullMonthNoDayAdapter} from '../../date-adapters/date-full-month-no-day-adapter';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {CurrencyPipe, DecimalPipe, formatCurrency, formatNumber} from '@angular/common';
import {VvrIconComponent} from "../../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {RouterLink} from "@angular/router";
import {MatFormField, MatInput, MatLabel, MatSuffix} from "@angular/material/input";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {FormsModule} from "@angular/forms";
import {MatButton, MatIconButton} from "@angular/material/button";
import {SortingIconComponent} from "../../sorting-icon.component";
import {CdkCopyToClipboard} from "@angular/cdk/clipboard";

@Component({
    selector: 'app-declaration-report',
    templateUrl: './declaration-report.component.html',
    styleUrls: ['./declaration-report.component.scss'],
    imports: [
        VvrIconComponent,
        MatTooltip,
        RouterLink,
        MatFormField,
        MatLabel,
        MatDatepickerToggle,
        MatDatepicker,
        MatInput,
        MatDatepickerInput,
        FormsModule,
        MatButton,
        MatRipple,
        SortingIconComponent,
        DecimalPipe,
        MatIconButton,
        CdkCopyToClipboard,
        CurrencyPipe,
        MatSuffix
    ],
    providers: [{
        provide: DateAdapter, useClass: DateFullMonthNoDayAdapter
    }]
})
export class DeclarationReportComponent extends SortingComponent<DeclarationReport> implements OnInit, OnDestroy {

    date = new Date();

    total: number;

    readonly statusGoedgekeurd = 2;

    constructor(
        private confirmDialogService: ConfirmDialogService,
        private declarationService: DeclarationService
    ) {
        super();
    }

    ngOnInit(): void {
        this.getReport();
    }


    private getReport() {
        this.subscriptions.add(
            this.declarationService.report(this.date).subscribe(report => {
                this.list.set(report.data);
                this.total = this.list().map(d => +d.amount || 0).reduce((p, c) => p + c, 0);
            })
        );
    }

    statusPayed(item: DeclarationReport) {
        this.confirmDialogService.confirm('Vergoeden',
            `Weet je zeker dat je de status van al deze declaraties met een totaal bedrag van
            ${formatCurrency(item.amount, 'nl', 'EUR')} wilt omzetten naar 'Vergoed'?`,
            'Omzetten naar Vergoed',
            'Nee').then(() => {
            this.subscriptions.add(this.declarationService.pay(item.declarations).subscribe(() => {
                this.getReport();
            }));
        }, () => {

        });
    }

    copyClip(amount) {
        return formatNumber(amount, 'nl', '0.2-2').replace('.', '');
    }

    chosenMonthHandler(date, datepicker) {
        this.date = date;
        this.getReport();
        datepicker.close();
    }


    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
